import {EmailModel} from "../../../core/sharedmodels/email/EmailModel";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {TableAsync} from "../../../core/components/table/tableAsync";
import {SlideIn} from "../../../core/components/slideIn/slideIn";
import {dateTimeStringFromApiToDate} from "../../../index";
import {
    StamdataEmailTableColumnsPostModel
} from "../../../services/api/stamdataEmail/stamdataEmailTableColumnsPostModel";
import {stamdataEmailResponseModel} from "../../../services/api/stamdataEmail/stamdataEmailResponseModel";
import {useState} from "react";
import {nameof} from "ts-simple-nameof";
import {ModalSize} from "../../../core/components/slideIn/modalSize";
import useStamdataApi from "../../../core/hooks/useStamdataApi";
import {EmailInfo} from "./emailInfo";

type ReceivedMailsProps = {
    userId: string;
}

export const SentMails = ({userId}: ReceivedMailsProps) => {
    const [selectedMail, setSelectedMail] = useState<EmailModel>();

    const modalTarget = "email-view-modal";
    const tableId = "sentMailsTable";
    const {stamdataEmailApi} = useStamdataApi();

    const renderTable = () => {
        return <TableAsync
            tableIdentifier={tableId}
            tableHeader={Localizer.profilepage_SentEmails()}
            renderTableHead={renderTableHead}
            initOrder={[3, "desc"]}
            asyncUrl={stamdataEmailApi.emailSentDatalist()}
            columns={emailTableColums()}
            getCustomPostData={() => {
                return {userId: userId}
            }}
            rowClickFunction={(email: EmailModel) => {
                setSelectedMail(email);
            }}
            showFilteredRecordsInfo
        />
    }

    const emailTableColums = (): DataTables.ColumnSettings[] => {
        let columns: DataTables.ColumnSettings[] = [];

        columns = columns.concat([
            {
                data: (data: stamdataEmailResponseModel) => data.subject,
            },
            {
                data: (data: stamdataEmailResponseModel) => data.fromName,
                orderable: false
            },
            {
                data: (data: stamdataEmailResponseModel) => data.originalRecipientName,
                orderable: false
            },
            {
                data: (data: stamdataEmailResponseModel) => data,
                render: (data: stamdataEmailResponseModel) => {
                    return `<div>${data.sentAt ? dateTimeStringFromApiToDate(data.sentAt).dateWithTimeFormat() : ""}</div>`;
                }
            }
        ]);

        return columns;
    }

    const renderTableHead = () => {
        return (
            <thead>
            <tr>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.Subject)}
                    data-priority="1">
                    {Localizer.global_subject()}
                </th>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.Sendby)}
                    data-priority="2">
                    {Localizer.createMail_SendBy()}
                </th>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.OriginalRecipientName)}
                    data-priority="3">
                    {Localizer.createMail_SendTo()}
                </th>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.SendAt)}
                    data-priority="4">
                    {Localizer.createMail_Send()}
                </th>
            </tr>
            </thead>
        );
    }

    return (
        <>
            {renderTable()}

            {selectedMail &&
                <SlideIn
                    id={modalTarget}
                    title={Localizer.global_email()}
                    actionText={Localizer.vejlederPage_creatingVejleder()}
                    actionOnCloseCallback={() => {
                        setSelectedMail(undefined)
                    }}
                    actionFinishedCallback={() => {
                        setSelectedMail(undefined)
                    }}
                    defaultOpen={true}
                    bodyContent={<EmailInfo email={selectedMail}/>}
                    modalSize={ModalSize.md}
                />
            }
        </>


    );
}
